// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2vDOb","content":"styles_content__5eOFk","checkbox":"styles_checkbox__yCSM1","checkboxLabel":"styles_checkboxLabel__2YazB"};